import { ArrowForwardIcon } from '@chakra-ui/icons'
import { Box, Button, VStack } from '@chakra-ui/react'
import React from 'react'
import { STEPS } from '../QuestionsPatienteView'
import { useAppSelector } from 'src/redux/hooks'

interface Props {
    step: number,
    setStep: React.Dispatch<React.SetStateAction<STEPS>>
}

const CategoriesQuestions: React.FC<Props> = ({ step, setStep }) => {
    const { categories } = useAppSelector((state) => state.question)

    const setCategory = (index: number) => {
        setStep(index)
    }

    return (
        <Box display={{ base: 'none', xl: 'block' }} flex={2} h='fit-content' position='sticky' top={20} left={0} >
            <Box py={4}>
                <VStack alignItems='flex-start' >
                    {categories && categories?.length > 0 && categories?.map((c, index) => (
                        <Button
                            key={index}
                            rightIcon={<ArrowForwardIcon />}
                            colorScheme={step === index ? 'blue' : 'gray'}
                            variant='ghost'
                            onClick={() => setCategory(c.id)}
                        >
                            {c.categ}
                        </Button>
                    ))}
                </VStack>
            </Box>
        </Box>
    )
}

export default CategoriesQuestions